import React from "react";

const formatTime = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const Message = ({ message, isUser }) => {
  if (message.type === "text") {
    return (
      <div className={`flex ${isUser ? "justify-end" : "justify-start"} mb-4`}>
        {!isUser && (
          <div className="avatar">
            <img src={message.avatar} alt="Mira" />
          </div>
        )}
        <div className={isUser ? "flex flex-col items-end" : ""}>
          <div
            className={
              isUser
                ? "message-sortant p-4 max-w-xs md:max-w-md"
                : "message-entrant p-4 max-w-xs md:max-w-md"
            }
          >
            <p>{message.text}</p>
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {formatTime(message.timestamp)}
          </div>
          {isUser && (
            <div className="message-status">
              <span className="message-sent status-animation">
                <i className="fas fa-check"></i>
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (message.type === "image") {
    return (
      <div className="flex justify-start mb-4">
        <div className="avatar">
          <img src={message.avatar} alt="Mira" />
        </div>
        <div className="image-message relative w-48 h-64">
          {message.link ? (
            <a
              href={message.link}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full h-full"
            >
              <img
                src={message.src}
                alt={message.alt}
                className="w-full h-full object-cover filter blur-lg"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center">
                <i className="fas fa-lock text-white text-2xl mb-2"></i>
                <span className="bg-white text-black px-3 py-1 rounded text-sm">
                  Dévérouiller la photo
                </span>
              </div>
            </a>
          ) : (
            <img
              src={message.src}
              alt={message.alt}
              className="w-full h-full object-cover"
            />
          )}
          <div className="text-xs text-gray-400 mt-1">
            {formatTime(message.timestamp)}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default Message;
